var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#1A73E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48.38,
    height: 49.46,
    transform: "translate(25.8198 25.26)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_110_9153",
    transform: "scale(0.00757576 0.00740741)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_110_9153",
    width: 132,
    height: 135,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIQAAACHCAMAAADgDgE7AAAAY1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+aRQ2gAAAAIHRSTlMAwIBAXbckn5U7YeS4sV7xWBzQyW4Q9YdBpI5QMQu6lq5jWtcAAAGeSURBVHja7dzdboJAEIbhEa2jUERU/Lf97v8qm9DsgQk2hVkcCN97uidPlrAbNlnEEFpVfC+lh9CyYyrijgA2Q0AcS4lW2hWBfTSDzjojsIxlgAFxjmWwILaRDCbEIo7BH6HwRyj8EQp/hMIfofBHKPwRCn+Ewh+h8Eco/BEKf4TCH6HwRyj8EQp/hKKhvB4qDQi7AUk9dn8TIkVj83rwZkDYDbnUnQwIs6GopC4zIKyG7C51WxgQRsO1kt+yNyCqpKHDXEJXWBH2tvBHrBHyO6FYAN4zUV7gjTivEOr1cSySF50uXwVCPc/EB/6ICCKIqCMiRESIiJAj4hNPHeaG8kgzsRZDKyKIaETY347dzFA26nWCCCKIIIKIjnuHJob2eGozrl2UCCLG8HZMeLEigggiiBgFYohf5RPeyokYFGKIJ7oTXqyIIIIIIogY1S5KBBGDRAzx42cQ6wQRAIgIEREiIkREyBGRw5z9SvcJ5uw37G/oq6P8u0eGnprFvkLS+68G9uilg7SpyhG/YiMtS3exCXkpHSqXEXvI634AxJ+MmBVjKOwAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.79eecb2cb8f0a4cf2f00d46a7c76295a.svg";
export { ForwardRef as ReactComponent };